import {
  colorSchemeLightCold,
  iconSetMaterial,
  themeQuartz,
} from 'ag-grid-community';

const general = themeQuartz;

const compact = themeQuartz.withParams({
  cellHorizontalPaddingScale: 0.7,
  fontSize: 12,
  headerFontSize: 13,
  headerFontWeight: 500,
  spacing: 4,
});

const auditing = themeQuartz
  .withParams({
    headerTextColor: '#25252D',
    headerFontFamily:
      'Satoshi-Variable,Satoshi-VariableItalic,Satoshi-Light,Satoshi-LightItalic,Satoshi-Regular,Satoshi-Italic,Satoshi-Medium,Satoshi-MediumItalic,Satoshi-Bold,Satoshi-BoldItalic,Satoshi-Black,Satoshi-BlackItalic',
    headerFontSize: 12,
    headerFontWeight: 700,
    headerBackgroundColor: '#F7F7F8',
    borderColor: '#EDEDED',
    wrapperBorderRadius: 8,
    fontSize: 12,
    cellHorizontalPadding: 32,
    rowHoverColor: 'rgba(0, 0, 0, 0.04)',
    rowHeight: 60,
    headerHeight: 48,
    spacing: 8,
  })
  .withPart(iconSetMaterial)
  .withPart(colorSchemeLightCold);

export const agGridThemes = {
  general,
  compact,
  auditing,
};
